import React from 'react'
import Link from 'gatsby-link'
import Img from 'gatsby-image'
import { withPrefix } from 'gatsby-link'

import pdfUrl from './Bond_101.pdf'
import cityPdfUrl from './Prop_A_Affordable_Housing.pdf'

import VoteYayImg from '../static/img/VoteYay_Logo_Horizontal_4C_small.png'

const BondPage = ({ data }) => {
  return (
    <div className="Bond101">
      <div
        className="container-fluid"
        style={{ borderTop: '1rem solid #5faf36' }}
      />
      <div className="container py-4">
        <div className="row" style={{ marginBottom: '2.5rem' }}>
          <div className="col-lg-6">
            <img
              src={VoteYayImg}
              alt="Vote Yay for Prop A"
              style={{ width: '100%' }}
            />
          </div>
          <div className="col-lg-6 Bond101__page-header--right">
            <h1 style={{ fontWeight: '800' }}>BOND 101 FAQs</h1>
          </div>
        </div>
        <div className="row">
          <div className="col">
            <div className="mb-3">
              <a href={pdfUrl}>Download the Bond 101 FAQs (PDF)</a>
            </div>

            <h3>What is a Proposition, aka “Prop”?</h3>
            <p>
              A “prop” is a proposition for voters to consider. It’s a ballot
              measure about local policies you can use your voice to put into
              effect.
            </p>

            <h3>What is an affordable Housing Bond?</h3>
            <p>
              An Affordable Housing Bond is an investment in the betterment of
              our community driven by the City’s partnership with local housing
              organizations. The Bond will fund programs through various
              nonprofits and community groups to build new affordable homes,
              repair existing ones, and create better lives for all Austinites.
            </p>

            <h3>What can Affordable Housing Bonds be used for?</h3>
            <p>
              Affordable Housing Bonds fund more things than one. They help
              nonprofits like Austin Habitat for Humanity build homes for
              low-wage workers and other nonprofits like Meals on Wheels Central
              Texas provide home repairs for seniors so they can age-in-place.
              It’s for more people than you may think – affordable housing can
              be for anyone who makes lower or moderate incomes because of how
              rapidly the housing crisis has escalated.
            </p>

            <h3>What is “Keep Austin Affordable”?</h3>
            <p>
              Keep Austin Affordable is a coalition of local nonprofits,
              businesses and community groups who want all of our neighbors to
              have a place to call home. Members like Austin Habitat for
              Humanity, Foundation Communities, LifeWorks, Caritas of Austin,
              Meals on Wheels Central Texas and HousingWorks Austin see the
              housing crisis as a high priority for the City to invest in
              mitigating and are committed to passing the Bond.
            </p>

            <h3>Who would be helped by the Bond?</h3>
            <p>
              Bus drivers, children’s teachers, and medical assistants;
              restaurant cooks, janitors, and the homeless; your Grandparents,
              caretakers, and veterans on fixed-incomes. They are the neighbors
              who make our community the diverse and “weird” Austin we all love.
            </p>

            <h3>Would the investment have a return?</h3>
            <p>
              Yes - and a large one at that. The 2013 Bond was for $65 million,
              which leveraged a 7:1 return ratio that was put into making our
              community stronger!
            </p>
            <h3>
              What about taxes - how much will they be raised with the
              Affordable Housing Bond?
            </h3>
            <p>
              The City is proposing 7 bonds, including investments for things
              like public safety, drainage, transportation, and parks. For all 7
              bonds combined, including Affordable Housing, the average
              homeowner could expect a $5/month increase. No single proposition
              is expected to increase taxes alone.
            </p>

            <h3>How can I support this?</h3>
            <p>
              Make sure you are{' '}
              <a href="https://www.usa.gov/register-to-vote">
                registered to vote
              </a>
              . Early voting begins October 22nd and will end November 2nd. The
              general election will be on Tuesday, November 6th. You can also
              follow{' '}
              <a href="https://keepaustinaffordable.com/">
                Keep Austin Affordable
              </a>{' '}
              by signing up for our newsletter and following on{' '}
              <a href="https://www.facebook.com/KeepAustinAffordable/">
                Facebook
              </a>
              .
            </p>

            <div className="mb-3">
              For info about the bond provided by the City,{' '}
              <a href={cityPdfUrl}>download the Prop A Brochure (PDF)</a> or{' '}
              <a href="https://www.austintexas.gov/2018bond">
                Visit the 2018 Bonds page.
              </a>
            </div>
          </div>
        </div>
      </div>
      <div
        className="container-fluid"
        style={{
          background: '#2E3131',
          color: '#FFFFFF',
          textAlign: 'center',
          fontFamily: 'BioRhyme',
          fontSize: '1.5rem',
          padding: '.8rem',
        }}
      >
        <span style={{ color: '#F04923' }}>PROP A</span> IS FOR AFFORDABLE
        HOUSING BONDS
      </div>
    </div>
  )
}

export default BondPage



// WEBPACK FOOTER //
// ./src/pages/bond101.js